import Table from "@/components/Table";
import Typography from "@/components/Typography";

interface InvestorsTableSectionProps {
  data: any[];
  columns: any[];
}

export default function InvestorsTableSection({ data, columns }: InvestorsTableSectionProps) {
  return (
    <div className="mb-8">
      <Typography variant="h5" color="grey900" className="mb-4">
        Investidores Associados
      </Typography>
      <Table
        data={data}
        columns={columns}
        onClickRow={(investorId: string) =>
          (window.location.href = `/investor/${investorId}?from=investment-manager`)
        }
        allowMainRowClick={true}
      />
    </div>
  );
}
